// src/contexts/FavoritesContext.js
import React, { createContext, useState, useEffect } from 'react';
import * as LocalStorage from '../utils/localStorage';

export const FavoritesContext = createContext({
  favorites: [],
  addFavorite: () => {},
  removeFavorite: () => {},
  isFavorite: () => false,
  clearFavorites: () => {},
});

export function FavoritesProvider({ children }) {
  const [favorites, setFavorites] = useState([]);

  // Load favorites from localStorage on mount
  useEffect(() => {
    const stored = LocalStorage.getFavorites();
    setFavorites(stored);
  }, []);

  const addFavorite = (productID) => {
    const updated = LocalStorage.addFavorite(productID);
    setFavorites(updated);
  };

  const removeFavorite = (productID) => {
    const updated = LocalStorage.removeFavorite(productID);
    setFavorites(updated);
  };

  const isFavorite = (productID) => {
    return LocalStorage.isFavorite(productID);
  };

  const clearFavorites = () => {
    const updated = LocalStorage.clearFavorites();
    setFavorites(updated);
  };

  const value = {
    favorites,
    addFavorite,
    removeFavorite,
    isFavorite,
    clearFavorites,
  };

  return (
    <FavoritesContext.Provider value={value}>
      {children}
    </FavoritesContext.Provider>
  );
}
